import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { recruitMessage } from "@/mocks/legalPages";

/** 採用ページ MESSAGE。落ち着いたトーンで方針を伝える。 */
export default function RecruitMessage() {
  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <Reveal>
          <SectionHeading en={recruitMessage.en} jp={recruitMessage.heading} />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-10 max-w-3xl space-y-5 md:mt-14">
            {recruitMessage.paragraphs.map((paragraph) => (
              <p key={paragraph} className="text-[13px] leading-[2.2] text-foreground-700 md:text-sm">
                {paragraph}
              </p>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}